import { GetterTree } from 'vuex';
import { IKrogerCheckoutState } from './state';
import { GET_KROGER_AUTH_CONFIG, GET_IS_GO_TO_CART_OPEN, GET_SESSION_ID } from './types';

const getters: GetterTree<IKrogerCheckoutState, IKrogerCheckoutState> = {
    [GET_KROGER_AUTH_CONFIG](state) {
        return state.krogerAuthConfig;
    },
    [GET_IS_GO_TO_CART_OPEN](state) {
        return state.goToCartOpen;
    },
    [GET_SESSION_ID](state): string {
        return state.sessionId;
    },
};

export default getters;
